// extracted by mini-css-extract-plugin
export default {"tip_box":"index_tip_box_UkW9T","tip":"index_tip_gzdbf"};